import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { addUserServicePost } from "./addUserService";
import { errorToast, successToast } from "../../../components/toastmessage/toastmessage";
import { handleUserValidation } from "./userValidation";


const useAddUserHook = (initialState) => {
    const navigate = useNavigate();
    const [userState, setUserState] = useState(initialState);
    const [errors, setError] = useState({})

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setUserState((prevFormState) => ({
            ...prevFormState,
            [name]: value,
        }));
    }

    const handleBlur = async () => {
        const newErrors = await handleUserValidation(userState);
        setError(newErrors)

    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const getUserValue = JSON.parse(sessionStorage.getItem("loginDetails"))
        let payload = {
            ...userState,
            tenantId: getUserValue?.tenantID
        }
        let valid = await handleUserValidation(payload)
        if (valid?.isValid) {
            try {
                let result = await addUserServicePost(payload)
                if (result?.status === 200) successToast(result?.data?.message);
                setUserState({})
            } catch (err) {
                errorToast(err?.response?.data?.error || err?.response?.data?.message)
            }
        }
        setError(valid)

    }

    const allowNumbersOnly = (e) => {
        let code = (e.which) ? e.which : e.keyCode;
        if (code > 31 && (code < 48 || code > 57)) {
            e.preventDefault();
        }
    }

    const handleGoBack = (e) => {
        e.preventDefault();
        navigate("/patient-registration")
    }
    return {
        errors,
        userState,
        setUserState,
        handleInputChange,
        handleSubmit,
        allowNumbersOnly,
        handleBlur,
        handleGoBack

    }


};


export default useAddUserHook;
